module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_03 (2).3924b6ff.png";